import type { EditorAPI } from '#packages/editorAPI';
import { SlotOpenerApiKey } from '#packages/apis';
import { getRestrictedZones } from '../store';
import { getIsMobileBlockReparentingEnabled } from '../utils/common';
import { reportBi } from '../bi';
import type { layoutTransitionsUtil } from '#packages/layoutUtils';
import type { CompLayout, CompRef } from '@wix/document-services-types';

interface ResetArgs {
  editorAPI: EditorAPI;
  dragTransition: layoutTransitionsUtil.Drag;
  initialCompLayout: CompLayout;
  selectedComp: CompRef[];
  layoutUpdate: (deltaX: number, deltaY: number) => void;
}

export function resetToInitialPositionIfNeeded(resetArgs: ResetArgs) {
  const {
    editorAPI,
    dragTransition,
    initialCompLayout,
    selectedComp,
    layoutUpdate,
  } = resetArgs;
  const slotOpenerAPI = editorAPI.host.getAPI(SlotOpenerApiKey);

  if (!getIsMobileBlockReparentingEnabled(editorAPI)) {
    return;
  }

  const hasRestrictedZones = getRestrictedZones().length > 0;

  const isSlotActive = slotOpenerAPI.getActiveSlot();

  if (hasRestrictedZones && !isSlotActive) {
    const { deltaX, deltaY } = dragTransition.getLayoutDelta(initialCompLayout);

    layoutUpdate(deltaX, deltaY);

    reportBi.mobileNoReparenting({ editorAPI, selectedComp });
  }
}
